import { render } from "./PartnerWithUs.vue?vue&type=template&id=06770503"
import script from "./PartnerWithUs.vue?vue&type=script&lang=js"
export * from "./PartnerWithUs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__